import { Component } from '@angular/core';
import { ListRendererWidgetBase } from '@capturum/builders/list-renderer';

@Component({
  selector: 'app-is-active-widget',
  templateUrl: './is-active-widget.component.html',
  styleUrls: ['./is-active-widget.component.scss'],
})
export class IsActiveWidgetComponent extends ListRendererWidgetBase {}
